import React, { useState } from "react";
import { Button, Message, Input } from "../../../BP2Components";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "util/IntlMessages";
import { useIntl } from "react-intl";

const CardReportSettings = ({ value }) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const [settings, setSettings] = useState({
      ...value
   });

   const handleChangeInput = (e) => {
      const optionName = e?.target?.name ? e.target.name : "";
      const optionValue = e?.target?.value ? e.target.value : e;
      setSettings({ ...settings, [optionName]: optionValue });
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "save.modal" }));
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label key="title" className="widget-settings__inner__label">
                     <IntlMessages id="settings.title" />:
                     <Input
                        type="text"
                        name="title"
                        onChange={handleChangeInput}
                        defaultValue={value?.title}
                     />
                  </label>
                  <label key="listId" className="widget-settings__inner__label">
                     <IntlMessages id="settings.listId" />:
                     <Input
                        type="number"
                        name="listId"
                        onChange={handleChangeInput}
                        defaultValue={value?.listId}
                     />
                  </label>
                  <label key="iconId" className="widget-settings__inner__label">
                     <IntlMessages id="settings.iconId" />:
                     <Input
                        type="text"
                        name="iconId"
                        onChange={handleChangeInput}
                        defaultValue={value?.iconId}
                     />
                  </label>
                  <label key="textColor" className="widget-settings__inner__label">
                     <IntlMessages id="settings.textColor" />:
                     <Input
                        type="color"
                        name="textColor"
                        onChange={handleChangeInput}
                        defaultValue={value?.textColor}
                     />
                  </label>
                  <label key="sumColumnTechname" className="widget-settings__inner__label">
                     <IntlMessages id="settings.sumColumnTechname" />:
                     <Input
                        type="text"
                        name="sumColumnTechname"
                        onChange={handleChangeInput}
                        defaultValue={value?.sumColumnTechname}
                     />
                  </label>
                  <label key="timeColumnTechname" className="widget-settings__inner__label">
                     <IntlMessages id="settings.timeColumnTechname" />:
                     <Input
                        type="text"
                        name="sumColumnTechname"
                        onChange={handleChangeInput}
                        defaultValue={value?.timeColumnTechname}
                     />
                  </label>
                  <label key="profile" className="widget-settings__inner__label">
                     <IntlMessages id="settings.profile" />:
                     <Input
                        type="text"
                        name="profile"
                        onChange={handleChangeInput}
                        defaultValue={value?.profile}
                     />
                  </label>
                  <label key="timeRange" className="widget-settings__inner__label">
                     <IntlMessages id="settings.timeRange" />:
                     <Input
                        type="text"
                        name="timeRange"
                        onChange={handleChangeInput}
                        defaultValue={value?.timeRange}
                     />
                  </label>
               </div>
               <Button key="btn" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default CardReportSettings;
